import type { ActionHandler } from './actionsAdaptater'
import { defaultActionRequest } from './actionsAdaptater'

export const overrideActionRequests: ActionHandler<any> =
  async function overrideActionRequests(dataProvider, action, metaData) {
    return await defaultActionRequest(dataProvider, action, metaData)
  }
